import React from "react";
import SearchFilterToolbar from "../../components/AdminInventoryManagement/SearchFilterToolbar";
import InventoryTabale from "../../components/AdminInventoryManagement/InventoryTabale";

const AdminInventoryPage = () => {
  return (
    <div className="min-w-0 w-full">
      <div className="w-full px-4 py-6 sm:px-6 xl:px-8">
        <div className="min-w-0 space-y-6">
          <SearchFilterToolbar />
          <InventoryTabale />
        </div>
      </div>
    </div>
  );
};

export default AdminInventoryPage;
